module.exports = __webpack_public_path__ + "static/media/v13.f8e19775.mp4";